import { ListaParticipante } from "./ListaParticipante";

export default ListaParticipante;